export const contractAddress = "0x2540C8bCb3ab831F705de45A388ccB9850336e13"; // Adresse de votre contrat CoinFlip
export const kwakTokenAddress = "0x23CdC6BAeb7454356cb2caBF6115af916150116F"; // Adresse du contrat KWAK